export interface LocationReport {
  id: string
  title: string
  location: string
  coordinates: [number, number]
  riskLevel: 'critical' | 'high' | 'moderate' | 'low'
  category:
    | 'Ideologi'
    | 'Politik'
    | 'Ekonomi'
    | 'Sosial Budaya'
    | 'Pertahanan Keamanan'
  deputy: string
  bindaRegion: string
  status: string
  timestamp: string
  description: string
  affectedArea: string
  estimatedImpact: string
  recommendations: string[]
  relatedCases: string[]
  aiSummary: string
  sources: string[]
}
export const bindaRegions = [
  'BINDA Aceh',
  'BINDA Sumatra Utara',
  'BINDA Sumatra Barat',
  'BINDA Riau',
  'BINDA Jambi',
  'BINDA Sumatra Selatan',
  'BINDA Lampung',
  'BINDA DKI Jakarta',
  'BINDA Jawa Barat',
  'BINDA Jawa Tengah',
  'BINDA Jawa Timur',
  'BINDA Bali',
  'BINDA Kalimantan Barat',
  'BINDA Kalimantan Tengah',
  'BINDA Kalimantan Selatan',
  'BINDA Kalimantan Timur',
  'BINDA Sulawesi Utara',
  'BINDA Sulawesi Tengah',
  'BINDA Sulawesi Selatan',
  'BINDA Maluku',
  'BINDA Papua',
  'BINDA Papua Barat',
]
export const locationReports: LocationReport[] = [
  {
    id: 'RPT001',
    title: 'Potensi Demonstrasi Massal di Jakarta',
    location: 'Jakarta Pusat',
    coordinates: [-6.2088, 106.8456],
    riskLevel: 'high',
    category: 'Politik',
    deputy: 'Deputi II',
    bindaRegion: 'BINDA DKI Jakarta',
    status: 'ongoing',
    timestamp: '2024-01-15 14:30',
    description:
      'Terdeteksi mobilisasi massa dalam jumlah besar melalui media sosial dan grup komunikasi terenkripsi. Estimasi 5,000-10,000 peserta akan berkumpul di area Istana Negara.',
    affectedArea: 'Jakarta Pusat, radius 5km dari Istana',
    estimatedImpact:
      'Gangguan lalu lintas signifikan, potensi penutupan jalan protokol, risiko eskalasi konflik',
    recommendations: [
      'Tingkatkan patroli di area strategis',
      'Koordinasi dengan Polri untuk pengamanan',
      'Monitor media sosial secara real-time',
      'Siapkan jalur evakuasi alternatif',
    ],
    relatedCases: ['ALT001', 'ALT003'],
    aiSummary:
      'Analisis AI menunjukkan pola mobilisasi terorganisir dengan indikasi koordinasi lintas platform. Sentiment analysis mendeteksi peningkatan retorika konfrontatif. Rekomendasi: Tindakan preventif segera dengan pendekatan dialogis.',
    sources: ['OSINT', 'HUMINT', 'SIGINT'],
  },
  {
    id: 'RPT002',
    title: 'Aktivitas Separatis di Perbatasan Papua',
    location: 'Jayapura',
    coordinates: [-2.5489, 140.7018],
    riskLevel: 'critical',
    category: 'Pertahanan Keamanan',
    deputy: 'Deputi VI',
    bindaRegion: 'BINDA Papua',
    status: 'ongoing',
    timestamp: '2024-01-15 10:15',
    description:
      'Pergerakan kelompok bersenjata terdeteksi di area perbatasan. Pola pergerakan menunjukkan kemungkinan upaya infiltrasi atau pengiriman logistik.',
    affectedArea: 'Perbatasan Papua-PNG, sektor utara',
    estimatedImpact:
      'Potensi konflik bersenjata, gangguan keamanan masyarakat lokal, risiko eskalasi regional',
    recommendations: [
      'Tingkatkan patroli perbatasan',
      'Koordinasi dengan TNI untuk pengamanan',
      'Libatkan tokoh masyarakat lokal',
      'Perkuat sistem early warning',
    ],
    relatedCases: ['ALT002'],
    aiSummary:
      'Pattern recognition menunjukkan peningkatan aktivitas 300% dalam 72 jam terakhir. Geospatial analysis mengidentifikasi 3 rute infiltrasi potensial. Threat level: CRITICAL. Diperlukan respons taktis segera.',
    sources: ['IMINT', 'HUMINT', 'GEOINT'],
  },
  {
    id: 'RPT003',
    title: 'Serangan Siber Infrastruktur Kritis',
    location: 'Jakarta',
    coordinates: [-6.1751, 106.865],
    riskLevel: 'critical',
    category: 'Pertahanan Keamanan',
    deputy: 'Deputi IX',
    bindaRegion: 'BINDA DKI Jakarta',
    status: 'ongoing',
    timestamp: '2024-01-15 16:45',
    description:
      'Serangan DDoS masif terdeteksi pada sistem infrastruktur kritis nasional. Pola serangan menunjukkan koordinasi tingkat tinggi dengan sumber dari multiple negara.',
    affectedArea: 'Sistem perbankan nasional, layanan publik digital',
    estimatedImpact:
      'Gangguan layanan perbankan, potensi kebocoran data sensitif, kerugian ekonomi Rp 500M+',
    recommendations: [
      'Aktifkan protokol cyber defense tingkat tertinggi',
      'Isolasi sistem yang terinfeksi',
      'Koordinasi dengan BSSN dan stakeholder terkait',
      'Siapkan sistem backup dan recovery',
    ],
    relatedCases: ['ALT005'],
    aiSummary:
      'Cyber threat intelligence mendeteksi APT signature dari actor state-sponsored. Attack vector analysis menunjukkan 5 entry points. Estimated damage: HIGH. Immediate incident response required.',
    sources: ['SIGINT', 'TECHINT', 'OSINT'],
  },
  {
    id: 'RPT004',
    title: 'Penyebaran Disinformasi Pemilu',
    location: 'Surabaya',
    coordinates: [-7.2575, 112.7521],
    riskLevel: 'moderate',
    category: 'Politik',
    deputy: 'Deputi III',
    bindaRegion: 'BINDA Jawa Timur',
    status: 'monitoring',
    timestamp: '2024-01-15 09:20',
    description:
      'Kampanye disinformasi terstruktur terdeteksi menyebar di media sosial. Konten manipulatif terkait proses pemilu menggunakan teknologi deepfake.',
    affectedArea: 'Jawa Timur, fokus pada pemilih milenial dan Gen Z',
    estimatedImpact:
      'Polarisasi politik meningkat, potensi konflik horizontal, distorsi persepsi publik',
    recommendations: [
      'Lakukan fact-checking dan counter-narrative',
      'Koordinasi dengan platform media sosial',
      'Edukasi literasi digital kepada masyarakat',
      'Monitor dan identifikasi aktor disinformasi',
    ],
    relatedCases: ['ALT004'],
    aiSummary:
      'NLP analysis mengidentifikasi 12 narasi inti dengan reach 2.5 juta user. Deepfake detection confidence: 87%. Bot network analysis menunjukkan koordinasi terorganisir. Rekomendasi: Counter-narrative campaign.',
    sources: ['OSINT', 'SOCMINT'],
  },
  {
    id: 'RPT005',
    title: 'Radikalisasi Ideologi di Kampus',
    location: 'Bandung',
    coordinates: [-6.9175, 107.6191],
    riskLevel: 'moderate',
    category: 'Ideologi',
    deputy: 'Deputi V',
    bindaRegion: 'BINDA Jawa Barat',
    status: 'monitoring',
    timestamp: '2024-01-15 11:30',
    description:
      'Terdeteksi aktivitas rekrutmen dan indoktrinasi ideologi radikal di beberapa kampus. Pola penyebaran melalui kajian tertutup dan media sosial terenkripsi.',
    affectedArea: '5 universitas di Bandung Raya',
    estimatedImpact:
      'Potensi radikalisasi mahasiswa, pembentukan sel dormant, ancaman jangka panjang',
    recommendations: [
      'Infiltrasi dan monitoring kelompok kajian',
      'Koordinasi dengan pihak kampus',
      'Program deradikalisasi preventif',
      'Identifikasi dan profiling aktor utama',
    ],
    relatedCases: [],
    aiSummary:
      'Behavioral analysis menunjukkan pola rekrutmen sistematis. Social network analysis mengidentifikasi 3 key influencer. Risk trajectory: ASCENDING. Diperlukan intervensi preventif multi-stakeholder.',
    sources: ['HUMINT', 'OSINT', 'SOCMINT'],
  },
  {
    id: 'RPT006',
    title: 'Fluktuasi Ekonomi Ekstrem Kalimantan',
    location: 'Balikpapan',
    coordinates: [-1.2379, 116.8529],
    riskLevel: 'high',
    category: 'Ekonomi',
    deputy: 'Deputi VII',
    bindaRegion: 'BINDA Kalimantan Timur',
    status: 'monitoring',
    timestamp: '2024-01-15 13:00',
    description:
      'Deteksi pola perdagangan mencurigakan dan capital flight signifikan. Indikasi money laundering dan transfer dana ilegal lintas negara.',
    affectedArea: 'Sektor pertambangan dan perbankan Kalimantan Timur',
    estimatedImpact:
      'Potensi kerugian negara Rp 1 Triliun, destabilisasi ekonomi regional',
    recommendations: [
      'Audit mendalam sektor pertambangan',
      'Koordinasi dengan OJK dan PPATK',
      'Tracking aliran dana mencurigakan',
      'Investigasi jaringan korporasi terkait',
    ],
    relatedCases: [],
    aiSummary:
      'Financial intelligence analysis mendeteksi anomali transaksi 450%. Shell company network analysis mengungkap 15 entitas terkait. Estimated illicit flow: Rp 1.2T. Priority: HIGH.',
    sources: ['FININT', 'OSINT', 'HUMINT'],
  },
  {
    id: 'RPT007',
    title: 'Konflik Sosial Antar Etnis Maluku',
    location: 'Ambon',
    coordinates: [-3.6954, 128.1814],
    riskLevel: 'high',
    category: 'Sosial Budaya',
    deputy: 'Deputi IV',
    bindaRegion: 'BINDA Maluku',
    status: 'ongoing',
    timestamp: '2024-01-15 08:45',
    description:
      'Eskalasi ketegangan antar kelompok etnis dengan insiden kekerasan sporadis. Provokasi melalui media sosial meningkat drastis.',
    affectedArea: 'Kota Ambon dan sekitarnya',
    estimatedImpact:
      'Potensi konflik horizontal massal, korban jiwa, pengungsian, trauma kolektif',
    recommendations: [
      'Mediasi tokoh agama dan adat',
      'Patroli bersama aparat keamanan',
      'Shutdown akun provokator',
      'Pembentukan pos komando terpadu',
    ],
    relatedCases: [],
    aiSummary:
      'Sentiment analysis menunjukkan spike hostility 280%. Historical pattern matching mengidentifikasi similarity dengan konflik 1999. Conflict prediction model: 78% probability escalation. Urgent de-escalation required.',
    sources: ['HUMINT', 'OSINT', 'SOCMINT'],
  },
  {
    id: 'RPT008',
    title: 'Illegal Mining Kalimantan Barat',
    location: 'Pontianak',
    coordinates: [-0.0263, 109.3425],
    riskLevel: 'moderate',
    category: 'Ekonomi',
    deputy: 'Deputi VII',
    bindaRegion: 'BINDA Kalimantan Barat',
    status: 'monitoring',
    timestamp: '2024-01-15 07:30',
    description:
      'Aktivitas pertambangan ilegal skala besar dengan indikasi keterlibatan jaringan transnasional. Kerusakan lingkungan signifikan.',
    affectedArea: 'Wilayah perbatasan Kalimantan Barat',
    estimatedImpact:
      'Kerugian negara Rp 500M/bulan, kerusakan ekosistem, konflik sosial',
    recommendations: [
      'Operasi penegakan hukum terpadu',
      'Koordinasi dengan negara tetangga',
      'Monitoring satelit area pertambangan',
      'Pemberdayaan ekonomi alternatif masyarakat',
    ],
    relatedCases: [],
    aiSummary:
      'Satellite imagery analysis mendeteksi 23 site aktif. Network analysis mengungkap supply chain 3 negara. Environmental impact: SEVERE. Economic loss: Rp 6B annually.',
    sources: ['IMINT', 'GEOINT', 'HUMINT'],
  },
  {
    id: 'RPT009',
    title: 'Propaganda Separatisme Papua Barat',
    location: 'Sorong',
    coordinates: [-0.8833, 131.2833],
    riskLevel: 'high',
    category: 'Ideologi',
    deputy: 'Deputi V',
    bindaRegion: 'BINDA Papua Barat',
    status: 'ongoing',
    timestamp: '2024-01-15 15:20',
    description:
      'Kampanye propaganda separatisme intensif melalui media internasional dan platform digital. Upaya pembentukan opini publik global.',
    affectedArea: 'Papua Barat, dengan jangkauan internasional',
    estimatedImpact:
      'Delegitimasi kedaulatan, tekanan diplomatik internasional, dukungan asing untuk separatisme',
    recommendations: [
      'Counter-narrative di forum internasional',
      'Diplomasi publik intensif',
      'Dokumentasi pembangunan Papua',
      'Engagement dengan media internasional',
    ],
    relatedCases: [],
    aiSummary:
      'Media monitoring mendeteksi 450 artikel negatif dalam 30 hari. Influence operation analysis mengidentifikasi 5 foreign actors. Global sentiment: 62% negative. Strategic communication campaign urgent.',
    sources: ['OSINT', 'HUMINT', 'SIGINT'],
  },
  {
    id: 'RPT010',
    title: 'Ancaman Terorisme Sulawesi',
    location: 'Makassar',
    coordinates: [-5.1477, 119.4327],
    riskLevel: 'critical',
    category: 'Pertahanan Keamanan',
    deputy: 'Deputi V',
    bindaRegion: 'BINDA Sulawesi Selatan',
    status: 'ongoing',
    timestamp: '2024-01-15 17:00',
    description:
      'Intelligence menunjukkan sel teroris aktif merencanakan serangan pada target publik. Komunikasi terenkripsi menunjukkan timeline 48 jam.',
    affectedArea: 'Makassar dan sekitarnya, target: mall, bandara, hotel',
    estimatedImpact:
      'Ancaman nyawa massal, trauma psikologis, gangguan ekonomi regional',
    recommendations: [
      'Operasi penangkapan preventif immediate',
      'Lockdown target potensial',
      'Koordinasi Densus 88',
      'Alert maksimal seluruh aparat',
    ],
    relatedCases: [],
    aiSummary:
      'SIGINT analysis mengidentifikasi communication spike 500%. Target prediction model menunjukkan 3 high-probability locations. Attack window: 48 hours. DEFCON 2. Immediate tactical response required.',
    sources: ['SIGINT', 'HUMINT', 'TECHINT'],
  },
]
